/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
function plural(val) {
  const n = val;
  return 5;
}
export default ["lu", [["Dinda", "Dilolo"], u, u], u, [["L", "N", "N", "N", "N", "N", "L"], ["Lum", "Nko", "Ndy", "Ndg", "Njw", "Ngv", "Lub"], ["Lumingu", "Nkodya", "Ndàayà", "Ndangù", "Njòwa", "Ngòvya", "Lubingu"], ["Lum", "Nko", "Ndy", "Ndg", "Njw", "Ngv", "Lub"]], u, [["C", "L", "L", "M", "L", "L", "K", "L", "L", "L", "K", "C"], ["Cio", "Lui", "Lus", "Muu", "Lum", "Luf", "Kab", "Lush", "Lut", "Lun", "Kas", "Cis"], ["Ciongo", "Lùishi", "Lusòlo", "Mùuyà", "Lumùngùlù", "Lufuimi", "Kabàlàshìpù", "Lùshìkà", "Lutongolo", "Lungùdi", "Kaswèkèsè", "Ciswà"]], u, [["kmp. Y.K.", "kny. Y. K."], u, ["Kumpala kwa Yezu Kli", "Kunyima kwa Yezu Kli"]], 1, [6, 0], ["d/M/y", "d MMM y", "d MMMM y", "EEEE d MMMM y"], ["HH:mm", "HH:mm:ss", "HH:mm:ss z", "HH:mm:ss zzzz"], ["{1} {0}", u, u, u], [",", ".", ";", "%", "+", "-", "E", "×", "‰", "∞", "NaN", ":"], ["#,##0.###", "#,##0%", "#,##0.00¤", "#E0"], "CDF", "FC", "Nfalanga wa Kongu", {
  "CDF": ["FC"],
  "JPY": ["JP¥", "¥"],
  "USD": ["US$", "$"]
}, "ltr", plural];
